export default __webpack_public_path__ + "static/media/schedule.1a9f3284.svg";